/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PredictiveQuestionDto } from './PredictiveQuestionDto';
export type PredictiveCampaignQuestionDto = {
    target: PredictiveCampaignQuestionDto.target;
    question: PredictiveQuestionDto;
};
export namespace PredictiveCampaignQuestionDto {
    export enum target {
        REGION_COUNTRY = 'REGION_COUNTRY',
        REGION_COUNTRY_INCLUDE = 'REGION_COUNTRY_INCLUDE',
        REGION_COUNTRY_EXCLUDE = 'REGION_COUNTRY_EXCLUDE',
        INDUSTRY_INCLUDE = 'INDUSTRY_INCLUDE',
        INDUSTRY_EXCLUDE = 'INDUSTRY_EXCLUDE',
        AUDIENCE_CHARACTERISTICS = 'AUDIENCE_CHARACTERISTICS',
        HEADCOUNT = 'HEADCOUNT',
        REVENUE = 'REVENUE',
        COMPANY_AGE = 'COMPANY_AGE',
        CONTACT_PERSON_ROLE_INCLUDE = 'CONTACT_PERSON_ROLE_INCLUDE',
        CONTACT_PERSON_ROLE_FREE_FORM_INCLUDE = 'CONTACT_PERSON_ROLE_FREE_FORM_INCLUDE',
        CONTACT_PERSON_ROLE_EXCLUDE = 'CONTACT_PERSON_ROLE_EXCLUDE',
        CONTACT_PERSON_ROLE_FREE_FORM_EXCLUDE = 'CONTACT_PERSON_ROLE_FREE_FORM_EXCLUDE',
        SIGNAL_INCLUDE = 'SIGNAL_INCLUDE',
        NO_SIGNAL = 'NO_SIGNAL',
        SIGNAL_EXCLUDE = 'SIGNAL_EXCLUDE',
        TOOL = 'TOOL',
        TOOL_FREE_FORM = 'TOOL_FREE_FORM',
        CLIENT = 'CLIENT',
        COMPETITOR = 'COMPETITOR',
    }
}

